
import { Component, Vue, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
import CheckListPrint from "./check-list-print.vue";
import DelegatePrint from "./delegate-print.vue";
const testingItem = namespace("testing-item");
import t from "@common/src/i18n/t";

const app = namespace("app");

@Component({
  components: { CheckListPrint, DelegatePrint }
})
export default class PrintDropdown extends Vue {
  @testingItem.Action getTestOrderDetail;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @Prop({ type: Object, default: () => {} })
  detailData: any;
  @Prop({ type: String, default: "button" }) // button text
  triggerStyleType: string;
  @Prop({ type: Boolean, default: false })
  isGetDetail: any;
  showPreviewPrint = false; // 结算单预览
  showDelegatePrint = false; // 避单结算单预览
  getData = false;
  showShangHaiPrint = false;

  handleCopyMenuClick(command) {
    if (command === "printCheck") {
      if (this.isGetDetail) {
        this.getTestOrderDetail({
          checkOrderNo: this.detailData.checkOrderNo
        }).then(data => {
          this.detailData.warningDetails = data.data.warningDetails;
          this.showPreviewPrint = true;
        });
      } else {
        this.showPreviewPrint = true;
      }
    } else if (command === "printDelegate") {
      this.showDelegatePrint = true;
    }
  }
  testOrderPrintObj: any = {
    id: "printMer1",
    popTitle: t("test.test-completion-sheet"),
    extraCss: "",
    extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
  };
  delegatePrintObj: any = {
    id: "printMer2",
    popTitle: t("service.order-ticket"),
    extraCss: "",
    extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
  };
  missDetailData: any = {};
}
